import { create } from 'zustand/index';
import { ItemEntity } from '@entities/Item/Types';

export interface State {
    selectedItems: ItemEntity[];
    addAllToCartLoading: boolean;
    addSelectedToCartLoading: boolean;
}

export interface Actions {
    setSelectedItems: (newSelectedItems: ItemEntity[]) => void;
    setAddAllToCartLoading: (isLoading: boolean) => void;
    setAddSelectedToCartLoading: (isLoading: boolean) => void;
}

export const useItemsSelectionStore = create<State & Actions>((set, get) => ({
    selectedItems: [],
    addAllToCartLoading: false,
    addSelectedToCartLoading: false,

    setSelectedItems: (newSelectedItems: ItemEntity[]) => {
        set({ selectedItems: newSelectedItems });
    },

    setAddAllToCartLoading: (isLoading: boolean) => {
        set({ addAllToCartLoading: isLoading });
    },

    setAddSelectedToCartLoading: (isLoading: boolean) => {
        set({ addSelectedToCartLoading: isLoading });
    },
}));
